import axios from "axios";

const baseAxios = axios.create({ withCredentials: true });

// Set the correct base URL for your server (CRA uses REACT_APP_ prefix)
baseAxios.defaults.baseURL =
  process.env.REACT_APP_BASE_URL || process.env.NEXT_PUBLIC_BASE_URL || "";
// ensure cookies (including httpOnly) are sent with requests
baseAxios.defaults.withCredentials = true;
if (!baseAxios.defaults.baseURL) {
  // warn in dev to help debugging when env var is missing
  // eslint-disable-next-line no-console
  console.warn(
    "BASE URL not set: set REACT_APP_BASE_URL (or NEXT_PUBLIC_BASE_URL) in your .env",
  );
}
// Add a request interceptor
baseAxios.interceptors.request.use(
  function (config) {
    // no Authorization header added; backend uses httpOnly cookies for auth
    return config;
  }, // function(config)
  function (error) {
    return Promise.reject(error);
  }, // function(error)
);

baseAxios.interceptors.response.use(
  function (response) {
    return response; // keep full response so callers using `res.data` continue to work
  }, // function(response)
  function (error) {
    const errorVal = error?.response?.data?.error;

    if ([401].includes(error?.response?.status)) {
      // logoutUser()
    }
    return Promise.reject(errorVal);
  },
);

export default baseAxios;
